import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const PythonTema8 = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/Tema8_Visualizacion_Datos.pdf`;
  /*const pdfUrl = "/pdf/Tema8_Visualizacion_Datos.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Tema 8: Visualización de Datos</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Tema 8: Visualización de Datos" />
      </Container>
    </>
  );
};

 export default PythonTema8;
